
//55
Object.defineProperty(exports, "__esModule", { value: true });
require("./ToggleSwitch.st.css");
module.exports.default = require("stylable/runtime").create(
    "root",
    "ToggleSwitchColor1224737128",
    {"root":"ToggleSwitchColor1224737128--root","colorUnchecked":"#999","colorChecked":"#999","colorUncheckedHover":"#999","colorCheckedHover":"#999","colorDisabled":"#999"},
    null,
    module.id
);



//////////////////
// WEBPACK FOOTER
// ../node_modules/wix-ui-core/dist/src/components/toggle-switch/ToggleSwitchColor.st.css
// module id = 1275
// module chunks = 0